var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import ItemStatusService from "../../src/Services/ItemStatus.service";
import ActivityItemTypeService from "../../src/Domain/ActivityItemType/ActivityItemType.service";
const SurveyResponseStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        labelKey: "name",
        fetchItemsById: (ids) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield ItemStatusService.getItemStatuses({
                activityItemTypeIds: [ActivityItemTypeService.SurveyId],
                ids,
            });
            return response.data;
        }),
        fetchOptions: (search) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield ItemStatusService.getItemStatuses({
                activityItemTypeIds: [ActivityItemTypeService.SurveyId],
                query: search,
            });
            return response.data;
        }),
        optionRenderer: function optionRenderer(surveyResponseStatus) {
            return _jsx("span", { children: surveyResponseStatus.name });
        },
    });
};
export default SurveyResponseStatusLookup;
